export default __webpack_public_path__ + "media/images/icons_fc/doc-08c39e159a5b17aeeec8b2352a60beb0.png";